import 'reflect-metadata'
import { Inject } from 'inversify-props'
import {
  ShippingMethodDocument,
  ShippingMethodQuery,
  ShippingMethodQueryVariables,
} from '~/graphql/types'
import { shippingMethodStore } from '~/utils/store-accessor'
import { ApolloClientService } from '~/services/apollo-client.service'
import { UserService } from '~/services/user.service'

export class ShippingMethodService {
  @Inject('ApolloClientService') apolloClientService!: ApolloClientService
  @Inject('UserService') userService!: UserService

  public store = shippingMethodStore

  async fetchAll(force = false) {
    if (this.store.fetchStarted && !force) {
      return
    }
    this.store.setFetchStarted(true)
    const data = (
      await this.apolloClientService.client.query<
        ShippingMethodQuery,
        ShippingMethodQueryVariables
      >({
        query: ShippingMethodDocument,
        variables: {
          where: {},
        },
      })
    ).data

    if (data) {
      this.store.setItems(data.shipping_method)
      this.store.setLoading(false)
    }
  }

  get methods() {
    return this.store.items
  }

  get loading() {
    return this.store.loading
  }
}
